import SelectBase from './Select2';
export * from './Select2';

export const Select2 = SelectBase;

export default Select2;
